import request from 'api/requestUtils'

export type QuoteDedupeKeys = {
  customerEmailDedupeKey: string
  multipleCustomerEmailDedupeKey?: string
}

export function updateQuoteFromCart(quoteId: string, keys: QuoteDedupeKeys, callbackDate?: string) {
  return request.patch(`/api/carts/quotes/${quoteId}?without_brand=1`, { ...keys, callbackDate }, { credentials: 'include' })
}
